module.exports = __webpack_public_path__ + "static/media/ps.8f640b1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/ps.svg
// module id = 228
// module chunks = 0